module.exports = __webpack_public_path__ + "assets/img/TrendingNow_Offre_2.3c97235c-ps.jpg";